import '../css/Counter.css';
import Review from './review';
const features = [
  {
    title: "Accurate & Up‑to‑Date Inventory",
    icon: "📦",
    description:
      "With BestRx’s integrated Wholesaler Interface and BestPOS, we monitor OTC product levels in real-time. Automated EDI regularly updates stock counts and pricing directly from suppliers—eliminating guesswork and ensuring availability. Our shelves are stocked and prices are accurate."
  },
  {
    title: "Smart Reordering & Inventory Insights",
    icon: "🔄",
    description:
      "Need restocking? No sweat. Our system offers advanced inventory and reorder reports—highlighting fast-moving essentials and identifying slow movers. We optimize stock so you always find what you need, while minimizing excess inventory."
  },
  {
    title: "Streamlined Shopping Experience",
    icon: "🛒",
    description:
      "BestPOS enables flexible payment options including EMV/chip cards, gift cards, EBT, and Text-to-Pay for remote transactions. We create custom promotions and loyalty rewards, making OTC shopping convenient and budget-friendly."
  },
  {
    title: "Insightful Performance Tracking",
    icon: "📊",
    description:
      "We stay on top of trends and customer needs via robust reporting tools. With detailed analytics on OTC sales, we quickly adapt—introducing popular items, adjusting pricing, and crafting promotions that align with your health priorities."
  }
];

function OverTheCounterMedication() {
  return (
    <div className="otc-page">
      <div className="otc-banner">
        <img
          src={'/img_8.874Z.png'}
          alt="OTC Banner"
          className="otc-banner-img"
        />
        <div className="otc-banner-overlay"></div>
        <div className="otc-banner-content">
          <h1>OTC Medications & Essentials</h1>
        </div>
      </div>
      <header className="otc-header">
        <h2>Everyday Health Solutions, Always Within Reach</h2>
        <p className="otc-tagline">
          Your trusted source for over-the-counter products, powered by smart technology and caring service.
        </p>
        <p className="otc-intro">
          At Quality Pharmacy, we offer a comprehensive range of OTC products, managed seamlessly through BestRx and BestPOS. Whether you need everyday essentials or health-specific solutions, our efficient system ensures items are available, visible, and easy to access—when you need them most.
        </p>
      </header>
      <div className="otc-features">
        {features.map((feature, idx) => (
          <div className="otc-feature" key={idx}>
            <div className="otc-icon" style={{ fontSize: "2rem", marginBottom: "12px", color: "#E21F46", textAlign: "center", animation: "bounce 1.2s infinite alternate" }}>{feature.icon}</div>
            <h3>{feature.title}</h3>
            <p>{feature.description}</p>
          </div>
        ))}
      </div>
      <div className="otc-benefits">
        <h4>What This Means for You</h4>
        <ul>
          <li><strong>Always Available:</strong> Get what you need when you need it—thanks to smart inventory and automatic updates.</li>
          <li><strong>Visible & Accessible:</strong> Find OTC items online and in our store effortlessly.</li>
          <li><strong>Flexible & Affordable:</strong> Enjoy easy payments, reward deals, and promotions tailored to your needs.</li>
          <li><strong>Informed & Responsive:</strong> We listen to shopping patterns and act fast to serve you better.</li>
        </ul>
      </div>
       <Review/>
    </div>
  );
}

export default OverTheCounterMedication;